// Verifica che l'import di React sia all'inizio del file
import * as React from 'react';
import PropTypes from 'prop-types';

/**
 * Componente selettore di orario che mostra solo orari consentiti
 */
const TimeSelector = ({ disabled = false, name, value, onChange, label, minHour = 8, maxHour = 20, step = 30, startMinutes = 0 }) => {
  // Genera gli orari disponibili in base ai parametri
  const generateTimeOptions = () => {
    const options = [];
    let totalMinutes = minHour * 60 + startMinutes;
    const endMinutes = maxHour * 60;

    while (totalMinutes <= endMinutes) {
      const h = Math.floor(totalMinutes / 60);
      const m = totalMinutes % 60;
      const hour = h.toString().padStart(2, '0');
      const minute = m.toString().padStart(2, '0');
      options.push(`${hour}:${minute}`);
      totalMinutes += step;
    }

    return options;
  }

  const timeOptions = generateTimeOptions();

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <select
        name={name}
        value={value}
        disabled={disabled}
        onChange={onChange}
        className="w-full p-2 border border-gray-300 rounded-md"
        required
      >
        <option value="">Seleziona orario</option>
        {timeOptions.map((time) => (
          <option key={time} value={time}>
            {time}
          </option>
        ))}
      </select>
    </div>
  );
};

TimeSelector.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  minHour: PropTypes.number,
  maxHour: PropTypes.number,
  step: PropTypes.number
};

export default TimeSelector;
